import { makeApiRequest } from './api';

export interface IPlatformNotification {
  id: string;
  type: string;
  title: string;
  message: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
  read: boolean;
}

// The API's global ResponseTransformInterceptor wraps every controller return
// in an envelope `{ status, success, data, message }`. The notifications
// controller itself returns `{ data: notifications, unreadCount }`, so the real
// payload lands under `response.data`, not at the top level.
interface INotificationsPayload {
  data?: IPlatformNotification[];
  unreadCount?: number;
}

interface INotificationsResponse {
  success?: boolean;
  data?: INotificationsPayload;
  unreadCount?: number;
}

export const getNotificationsService = async (
  token: string
): Promise<{ items: IPlatformNotification[]; unreadCount: number }> => {
  const response = await makeApiRequest<INotificationsResponse>(
    '/notifications',
    { method: 'GET', token }
  );
  const payload = response?.data;
  return {
    items: Array.isArray(payload?.data) ? payload.data : [],
    unreadCount: payload?.unreadCount ?? response?.unreadCount ?? 0,
  };
};

export const markNotificationReadService = async (
  id: string,
  token: string
): Promise<void> => {
  await makeApiRequest(`/notifications/${id}/read`, {
    method: 'PATCH',
    token,
  });
};

export const markAllNotificationsReadService = async (
  token: string
): Promise<void> => {
  await makeApiRequest('/notifications/read-all', {
    method: 'POST',
    token,
  });
};
